<script>
  // components
  import TwoColumnRow from './TwoColumnRow.svelte';

  /**
   * A readable Svelte store of an individual Race.
   *
   *  @type {import('../types.d').RaceFeed}
   */
  export let feed;
  $: racesStore = $feed;

  /**
   * @type {Map<string, import('../types.d').Crosswalk>}
   */

</script>

<table class="summary-results">
  <thead class="sticky-top">
    <tr>
      <th scope="col" class="text-center text-uppercase">District</th>
      <th colSpan={2} scope="col" class="text-uppercase">Candidates</th>
      <th scope="col" class="text-right text-uppercase">
        % In<span class="invisible"></span>
      </th>
    </tr>
  </thead>
  <tbody>
    {#each racesStore as r}
    {#if r.seat_number != 0}
        <TwoColumnRow 
        candidates = {r.candidates}
        districtNumber={r.seat_number}
        isUncontested={r.is_uncontested}
        eevp={r.eevp}
        totalVotes={r.total_votes}
        />
    {/if}
    {/each}
  </tbody>
</table>